/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {DialogContextInterface, MkadSummaryListInterface} from '@shared/interface';

export enum SensorTypeEnum {
  Analog,
  Digital,
  Serial,
  Interrupt,
  PWM = '10',
  Virtual = '20',
}

export enum VariableSensorTypeEnum {
  number,
  string,
  boolean,
}

export enum VariableCalcMethodEnum {
  direct,
  min,
  max,
  avg,
  sum,
  count,
  stdDeviation,
}

export enum SensorSerialTypeEnum {
  query,
  continuous,
}

export interface SensorSerialInterface {
  serial_type: SensorSerialTypeEnum;
  sot: string | null;
  eot: string | null;
  data_length: number;
  data_separator: string | null;
}

export interface SensorVarListInterface {
  name: string;
  short_name: string;
  measurement_unit: string;
  icon_class: string;
  var_start: number | null;
  var_length: number | null;
}

export interface SensorVarInterface {
  id: number | null;
  index: number;
  name: string;
  short_name: string;
  measurement_unit: string;
  type: VariableSensorTypeEnum;
  calc_method: number;
  read_times: number;
  formula: string;
  min_value: number | string;
  max_value: number | string;
  var_start: number | null;
  var_length: number | null;
  icon: number;
  icon_class: string;
  is_used: boolean;
}

export interface SensorsListInterface {
  id: number;
  name: string;
  vendor: string;
  reference: string;
  type_label: string;
  enabled: boolean;
  sensor_vars: SensorVarListInterface[];
  is_used: boolean;
}

export interface SensorsFormInterface {
  id?: number;
  name: string;
  vendor: string;
  reference: string;
  type: SensorTypeEnum;
  type_label?: string;
  enabled: boolean;
  digital_class: number | null;
  sensor_serial: SensorSerialInterface | null;
  sensor_vars: SensorVarInterface[];
  is_used: boolean;
}

export interface SensorDialogContextInterface extends Pick<DialogContextInterface, 'isEditing'> {
  sensor?: SensorsListInterface;
}

export interface SensorVarSummaryInterface extends MkadSummaryListInterface {
  type: SensorTypeEnum;
}

export interface SensorSummaryInterface extends SensorVarSummaryInterface {
  sensor_vars: SensorVarSummaryInterface[];
  enabled: boolean;
}

